import {toast, ToastOptions, Id} from 'react-toastify'

import {getErrorMessage} from '@/utils/errorMessages'

const notifyError = (
    error: unknown,
    fallback?: string,
    options?: ToastOptions,
): Id => (
    toast.error(getErrorMessage(error, fallback), options)
)

export default notifyError
